import React, { useState } from 'react'
import PropTypes from 'prop-types'

export default function Faqs({ section_id }) {
  const faqsData = [
    {
      question: 'Do I need to open source my model to win?',
      answer: 'Yes, The TTS model submitted to the hackathon, any custom dataset used to create said model, its training, inference and the REST API server code, must be made available to the public under the MIT licence. Failure to do so will result in disqualification.'
    },
    {
      question: 'Can I use external data?',
      answer: 'Yes, you can use any data to train the TTS model. If any custom dataset is used during the training process it must be opensourced under the MIT licence. Failure to do so will result in disqualification.'
    },
    {
      question: 'What if I am outside of India?',
      answer: 'There are no regional restrictions to the competition.'
    },
    {
      question: 'How will the evaluation team contact me?',
      answer: 'Winners of the first round of the hackathon will be contacted via email by challenge.syspin@gmail.com. The email address can be used to reach out with queries, So, please be on the lookout!'
    },
    {
      question: 'Any limit on the number of team members?',
      answer: 'No.'
    },
    {
      question: 'Can we add more team members later?',
      answer: 'No.'
    },
    {
      question: 'Can we use pretrained TTS models?',
      answer: 'Yes. You can use pretrained TTS models to train your Model.'
    },
    {
      question: 'Can I still participate  if I’m not affiliated with any organization?',
      answer: 'Yes you can, you can register as independent.'
    },
    {
      question: 'Should we train multi-lingual models or mono-lingual models for the required target speaker combination?',
      answer: 'We expect all submissions to be multi-lingual models.'
    },
    {
      question: 'How do I register for the Hackathon?',
      answer: 'As the registration process uses google\'s form sevice, ensure you\'ve logged in to your gmail account and click the register now button. fill out the details, agree to the terms and conditions and hit submit.'
    }
  ]

  // track which index is open; -1 = none
  const [openIndex, setOpenIndex] = useState(-1)

  const toggle = idx => {
    setOpenIndex(openIndex === idx ? -1 : idx)
  }

  return (
    <section id={section_id} className="faqs-section">
      <h2 className="h1-medium section-title title-navy-blue pb-2 about-title">Frequently asked questions</h2>
      {/* <p className="faqs-subtitle title-navy-blue">
        Everything you need to know about the hackathon
      </p> */}
      <div className="jostRegular h5-small section-title title-dark-grey about-text">   

      <ul className="faqs-list">
        {faqsData.map((item, idx) => (
          <li key={idx} className="faq-item">
            <button
              className="faq-question"
              onClick={() => toggle(idx)}
            >
              <span className="h2-large jostRegular section-title pb-2 title">{item.question}</span>
              <span className="faq-icon">
                {openIndex === idx ? '–' : '+'}
              </span>
            </button>

            {openIndex === idx && (
              <div className="faq-answer jostRegular h5-small title-dark-grey about-text">
                {item.answer}
              </div>
            )}
          </li>
        ))}
      </ul>
      </div>
    </section>
  )
}

Faqs.propTypes = {
  section_id: PropTypes.string.isRequired
}
